import React, { useContext, useEffect } from "react";
import PaymentToggle from "../../KPIs/FinancialKPIs/PaymentToggle/PaymentToggle";
import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import "./stylesRouting.css";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

function Routing() {
  usePageTitle(AppStrings.PAYMENTS_ROUTING);

  const { setActiveSidebarTab } = useContext(AppContext);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PAYMENTS, "PAYMENTS_ROUTING");
  }, [setActiveSidebarTab]);

  return (
    <>
      <div className="routing-container">
        <PaymentToggle />
      </div>
    </>
  );
}

export default Routing;

